const LicenceSuspensionTypeValues = {
    ALCOHOL_RELATED: 'ALCOHOL_RELATED',
    CRIMINAL_RELATED: 'CRIMINAL_RELATED',
    TOO_MANY_CONVICTIONS: 'TOO_MANY_CONVICTIONS',
    FINE_NON_PAYMENT: 'FINE_NON_PAYMENT',
    OTHER_ADMIN: 'OTHER_ADMIN',
    OTHER_NON_ADMIN: 'OTHER_NON_ADMIN',
};

export default LicenceSuspensionTypeValues;
